/**
 * @fileoverview Provides a function for automatically fixing code issues based on a specified check command and AI model. It runs the check command, captures the output, and uses an AI model to generate code changes that address the identified problems.
 */

import { Model } from '@iterator/shared-node/ai/llm_types'
import { generateCodeWithStreamV2 } from './generate/generate_v2'
import { debug, debug_block, print_ai_block } from '@iterator/shared-node/util/logging'
import { exec } from 'child_process'
import { promisify } from 'util'

const execAsync = promisify(exec)

export async function doFix(directory: string, model: Model, checkCommand: string): Promise<void> {
  debug('doFix', { directory, model })
  print_ai_block('Check command', checkCommand)

  let output = ''

  try {
    const { stdout, stderr } = await execAsync(checkCommand, { cwd: directory })
    output = stdout || stderr
  } catch ({ stdout, stderr }: any) {
    output = stdout || stderr
  }

  print_ai_block('Check command output', output)
  if (!output.trim()) {
    debug('No issues found. Nothing to fix.')
    return
  }

  debug_block('Check command output', output)

  const prompt = `The following command was run and produced output indicating issues:

<command>
${checkCommand}
</command>

<output>
${output}
</output>

Please first describe the each of the errors and provide a quick explanation of how to fix them. Then, generate code changes to fix these issues. Before each code change, provide a could sentances explaining the error and the fix. If there are test errors, favor modifying the code and not the tests.
`

  await generateCodeWithStreamV2(directory, prompt, model, 'embedding')
}
